'use strict';

frontendApp.directive('iioNavigation', ['$rootScope', '$location', 'StateService', 'ProjectService', 'NavigationService', 'InviteService', 'AccountService', 'AdvancedSearchService', 'TagService', 'TagCategoryService', 'PreferenceService', 'ReviewMetricsService', '$routeParams',
  function ($rootScope, $location, StateService, ProjectService, NavigationService, InviteService, AccountService, AdvancedSearchService, TagService, TagCategoryService, PreferenceService, ReviewMetricsService, $routeParams) {
    return {
      restrict: 'E',
      templateUrl: 'partials/navigation.html',
      scope: {},
      link: function (scope, element, attrs) {
        scope.loggedIn = StateService.IsLoggedIn();
        scope.notifications = 6;
        scope.$routeParams = $routeParams;
        scope.Status = app.model.project.Status;

        scope.project = ProjectService.GetCurrentProject();

        scope.reviewedTag = null;

        scope.$watch("project", function (project) {
          if (project) {
            AdvancedSearchService.FindAll(project).then(function (searches) {
              scope.savedSearches = app.model.search.AdvancedSearch.FromList(searches);
            });

            TagCategoryService.findByName('Batch', function (category) {
              TagService.GetAll(
                project.id,
                category.id,
                0,
                500,
                function (batches) {
                  scope.assignedBatches = batches.tags;
                },
                true
              );
            });

          }
        });

        $rootScope.$on("FeedService.SearchAssigned", function () {
          AdvancedSearchService.FindAll(scope.project).then(function (searches) {
            scope.savedSearches = app.model.search.AdvancedSearch.FromList(searches);
          });
        });

        $rootScope.$on("AdvancedSearch.ListUpdated", function (event, searches) {
          scope.savedSearches = app.model.search.AdvancedSearch.FromList(searches);
        });

        $rootScope.$on("FeedService.BatchAssigned", function () {
          TagCategoryService.findByName('Batch', function (category) {
            TagService.GetAll(
              scope.project.id,
              category.id,
              0,
              500,
              function (batches) {
                scope.assignedBatches = batches.tags;
              },
              true
            );
          });
        });

        scope.$on('ProjectService.CurrentProjectChanged', function (event, project) {
          if (project && (!scope.project || scope.project.id !== project.id)) {
            scope.project = project;
          }
        });

        scope.$on(EVENTS.LOGIN_REQUIRED, function (event) {
          scope.loggedIn = false;
        });

        scope.$on(EVENTS.LOGIN_CONFIRMED, function (event) {
          scope.loggedIn = true;
        });

        scope.active = NavigationService.getActive();

        scope.isActiveMainNavItem = function (tabName) {
          return (NavigationService.getActiveMainNavItem() === tabName) ? 'active' : '';
        };

        scope.isActiveSubNavItem = function (tabName) {
          return (NavigationService.getActiveSubNavItem() === tabName) ? 'active' : '';
        };

        scope.mainNavItems = NavigationService.getMainNavItems();
        scope.invites = InviteService.getInvites();

        scope.showChat = function () {
          window.showChat();
        };

        scope.selectedBatch = null;
        scope.expandedBatches = {};

        scope.toggleExpandBatch = function (batch) {
          if (batch.id in scope.expandedBatches) {
            delete scope.expandedBatches[batch.id];
          } else {
            scope.expandedBatches[batch.id] = true;
            ReviewMetricsService.BroadcastNumReviewedNotReviewed(scope.project.id, batch.id);
          }
        };

        scope.handleBatchClick = function (batch, reviewState) {
          // scope.selectedBatch = batch;
          $location.path('/project/' + scope.project.id + "/home/batch/" + batch.id + (reviewState ? "/" + reviewState : ""));
        };

        scope.handleSearchClick = function (search) {
          $rootScope.$broadcast("navigation.batch.deselect");
          $location.path('/project/' + scope.project.id);
          $rootScope.$broadcast("SearchContext.Changed.Externally", app.model.search.SearchContext.Project);
          $rootScope.$broadcast("Search.SearchExecuted.Externally", search);
        };

        scope.$on("browse.batch.selected", function (e, obj) {
          scope.selectedBatch = obj.batch;
          scope.reviewState = obj.reviewState;

          if (obj.reviewState === 'reviewed' || obj.reviewState === 'notReviewed') {
            scope.expandedBatches[obj.batch.id] = true;
          }
        });

        scope.$on("ReviewedChart.Triggered", function (event, batchName) {
          var batch = _.findWhere(scope.assignedBatches, {name: batchName});
          scope.handleBatchClick(batch, "reviewed");
        });

        scope.$on("NotReviewedChart.Triggered", function (event, batchName) {
          var batch = _.findWhere(scope.assignedBatches, {name: batchName});
          scope.handleBatchClick(batch, "notReviewed");
        });

        scope.$on("navigation.batch.deselect", function (event) {
          scope.selectedBatch = null;
        });

      }
    }
  }]);
